import {
    ContentDataDefinitionLoader,
    createRegisterableComponentWithData,
} from '@news-mono/web-common'
import React, { useContext } from 'react'
import {
    JournoProfileArticleCardList,
    JournoProfileArticleCardListProps,
} from './JournoProfileArticleCardList'
import { CollectionDataContext } from '../../../contexts/CollectionDataContext/CollectionDataContext'

export const JournoProfileArticleCardListRegistration =
    createRegisterableComponentWithData(
        'journo-profile-card-list',
        ContentDataDefinitionLoader,
        (
            {
                expectedItemCount,
                adUnits,
                adTargeting,
            }: Omit<
                JournoProfileArticleCardListProps,
                'items' | 'onEvent' | 'api' | 'adState'
            >,
            { dataDefinitionArgs, ...initialData },
            { onEvent, adState, config },
        ) => {
            const contextData = useContext(CollectionDataContext)

            let data = initialData

            if (dataDefinitionArgs.type === 'context') {
                data = contextData.forId(
                    dataDefinitionArgs.contextId,
                ).collectionData
            }
            return (
                <JournoProfileArticleCardList
                    items={
                        data.loaded
                            ? {
                                  loaded: true,
                                  result: data.result.publications,
                              }
                            : { loaded: false }
                    }
                    adUnits={adUnits}
                    expectedItemCount={expectedItemCount}
                    onEvent={onEvent}
                    api={config.contentApi}
                    adState={adState}
                    adTargeting={adTargeting}
                    config={config}
                />
            )
        },
    )
